import { endpoints } from "config";

export const META_DEFAULT_OG_IMAGE = `${endpoints.cdn}/static-images/sodastream-dtc/SS-Fresh-Blue-Logo.png`;
export const PRIMARY_COLOR = "#75a7ad";